import { Module, StatusPanelDef } from '@ag-grid-community/core'
import { EnterpriseCoreModule } from '@ag-grid-enterprise/core'
import { StatusBarModule } from '@ag-grid-enterprise/status-bar'
import { SelectedRowsStatusBarComp } from '@helios/generic-components'
import { IssueCountStatusBar } from './issue-count-status-bar/issue-count-status-bar'
import { OmegaTimestampStatusBar } from './omega-timestamp-status-bar/omega-timestamp-status-bar'
import { TotalRowsCountStatusBar } from './total-rows-status-bar/total-rows-status-bar'

export const accountListStatusBarModuleName = 'hsAccountListStatusBarModule'
export const selectedRowsStatusBar = 'hsSelectedRowsStatusBar'
export const totalRowsStatusBar = 'hsTotalRowsStatusBar'
export const issueCountStatusBar = 'hsIssueCountStatusBar'
export const omegaTsStatusBar = 'hsOmegaTsStatusBar'

export const accountListStatusBarPanel: { statusPanels: StatusPanelDef[] } = {
  statusPanels: [
    {
      statusPanel: totalRowsStatusBar,
      align: 'left',
    },
    {
      statusPanel: selectedRowsStatusBar,
      align: 'left',
    },
    {
      statusPanel: issueCountStatusBar,
      align: 'right',
    },
    {
      statusPanel: omegaTsStatusBar,
      align: 'right',
    },
  ],
}

export const AccountListStatusBarModule: Module = {
  moduleName: accountListStatusBarModuleName,
  userComponents: [
    {
      componentName: totalRowsStatusBar,
      componentClass: TotalRowsCountStatusBar,
    },
    {
      componentName: selectedRowsStatusBar,
      componentClass: SelectedRowsStatusBarComp,
    },
    {
      componentName: issueCountStatusBar,
      componentClass: IssueCountStatusBar,
    },
    {
      componentName: omegaTsStatusBar,
      componentClass: OmegaTimestampStatusBar,
    },
  ],
  dependantModules: [StatusBarModule, EnterpriseCoreModule],
}
